var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"messages"},[_c('b-toaster',{attrs:{"name":"b-toaster-bottom-left"}}),_vm._l((_vm.getMessages),function(message){return _c('Message',{key:message.id,attrs:{"message":message}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }